// next
import { Stack } from '@mui/material';
import { Box } from '@mui/system';
import NextLink from 'next/link';
import { ServiceProps } from 'src/@types/service';
import Routes from 'src/routes';
// components
import { TextMaxLine } from '../../components';
import Image from '../../components/NextSanityImage';
// utils

// ----------------------------------------------------------------------

type Props = {
  service: ServiceProps;
  onSiderbar?: boolean;
};

export default function ProjectRelatedServiceItem({ service, onSiderbar }: Props) {
  const { title, header, slug } = service;

  const as = Routes.service(slug.current);
  const href = Routes.service('[slug]');

  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems={{ xs: 'flex-start', md: 'center' }}
      sx={{ width: 1, borderRadius: 1.5, border: '1px solid', borderColor: 'grey.200' }}
    >
      <Box
        sx={{
          overflow: 'hidden',
          position: 'relative',
          width: 80,
          height: 80,
          flexShrink: 0,
          borderRadius: 1.5,
        }}
      >
        <Image ratio="1/1" alt={title} src={header} layout="intrinsic" width={100} height={100} />
      </Box>
      <Stack spacing={onSiderbar ? 0.5 : 1}>
        <NextLink passHref as={as} href={href}>
          <TextMaxLine variant={onSiderbar ? 'subtitle2' : 'h6'} asLink>
            {title}
          </TextMaxLine>
        </NextLink>
      </Stack>
    </Stack>
  );
}
